import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Divider, Flex, Image, Stack, Text } from '@mantine/core';
import classes from './Divider.module.css';
import { KycCharacter } from './KycCharacter';
export const KycEmailContent: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Stack h="calc(100vh - 190px)" gap={10} p={10}>
      <Flex direction="column" align={{
      sm: 'center',
      lg: 'start'
    }} mt={40}>
        <Text fz={24} className={gunterzBold.className}>
          {i18n._('Welcome to')}
        </Text>
        <Image src="/assets/kyc/prime.svg" w={{
        sm: 160,
        lg: 189
      }} h={{
        sm: 62,
        lg: 67
      }} />
      </Flex>
      <Divider my={14} classNames={classes} />
      <Box>
        <Text fz={{
        sm: 18,
        lg: 21
      }} c="var(--text-dark)" className={gunterzBold.className} ta={{
        base: 'center',
        lg: 'left'
      }}>
          {i18n._('By completing the steps below you’ll gain a level 2 rank, which grants you UP TO A ')}
          <Text span inherit c="var(--text-prime)">
            {i18n._('1.3x multiplier!')}
          </Text>
        </Text>
      </Box>

      <KycCharacter visible="sm" hidden="lg" />
    </Stack>;
};